import type { ExtendedColumnDef } from "components/Datatable";

import type { StoreAccountView } from "@/services/dtos/store-bank-account.dto";

import { formatActiveLabel } from "../../types";

export const STORE_VIEW_MODAL_TITLE = "Contas correntes na base da loja";
export const STORE_VIEW_MODAL_DESCRIPTION =
  "Visualização somente leitura das contas correntes cadastradas na base de dados da loja.";

export const STORE_VIEW_EMPTY_MESSAGE =
  "Nenhuma conta corrente encontrada na base da loja.";

export const STORE_VIEW_COLUMN_LABELS = {
  BANK_NUMBER: "Banco",
  BANK_NAME: "Nome do Banco",
  AGENCY: "Agência",
  SEQUENCE: "Seq",
  ACCOUNT: "Conta",
  ACTIVE: "Ativo",
} as const;

export const STORE_VIEW_COLUMNS: ExtendedColumnDef<StoreAccountView>[] = [
  {
    id: "bankNumber",
    header: STORE_VIEW_COLUMN_LABELS.BANK_NUMBER,
    accessorFn: (row) => row.bankNumber,
  },
  {
    id: "bankName",
    header: STORE_VIEW_COLUMN_LABELS.BANK_NAME,
    accessorFn: (row) => row.bankName,
  },
  {
    id: "agency",
    header: STORE_VIEW_COLUMN_LABELS.AGENCY,
    accessorFn: (row) => row.agency,
  },
  {
    id: "sequence",
    header: STORE_VIEW_COLUMN_LABELS.SEQUENCE,
    accessorFn: (row) => row.sequence,
  },
  {
    id: "account",
    header: STORE_VIEW_COLUMN_LABELS.ACCOUNT,
    accessorFn: (row) => row.account,
  },
  {
    id: "active",
    header: STORE_VIEW_COLUMN_LABELS.ACTIVE,
    accessorFn: (row) => formatActiveLabel(row.active),
  },
];
